// Config panel for the "check_extension_available" condition block
// Checks SIP registration + call activity status for an extension
import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Alert,
  FormControlLabel,
  Checkbox,
} from '@mui/material';

const CheckExtensionAvailableConfig = ({ config, onChange, onSummaryChange }) => {
  const handleChange = (field, value) => {
    const updated = { ...config, [field]: value };
    onChange(updated);
    const ext = updated.extension || '?';
    const checks = [];
    if (updated.checkRegistration !== false) checks.push('reg');
    if (updated.checkBusy !== false) checks.push('idle');
    onSummaryChange(`${ext} ${checks.join('+') || 'any'}?`);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Check if a SIP extension is registered with Asterisk and not currently on a call.
        True = available, False = unavailable.
      </Typography>

      <TextField
        size="small"
        label="Extension"
        value={config.extension || ''}
        onChange={(e) => handleChange('extension', e.target.value)}
        required
        placeholder="{{callee}}"
        helperText="Supports variables: {{callee}}, {{caller}}, or a specific extension like 7001"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={config.checkRegistration !== false}
            onChange={(e) => handleChange('checkRegistration', e.target.checked)}
            size="small"
          />
        }
        label={
          <Typography variant="body2">
            Check registration status
          </Typography>
        }
      />
      <Typography variant="caption" color="text.secondary" sx={{ mt: -1.5, ml: 4 }}>
        Is the device registered with Asterisk? (updated every ~30 seconds)
      </Typography>

      <FormControlLabel
        control={
          <Checkbox
            checked={config.checkBusy !== false}
            onChange={(e) => handleChange('checkBusy', e.target.checked)}
            size="small"
          />
        }
        label={
          <Typography variant="body2">
            Check if currently on a call
          </Typography>
        }
      />
      <Typography variant="caption" color="text.secondary" sx={{ mt: -1.5, ml: 4 }}>
        Is the extension currently ringing or in an active call?
      </Typography>

      <Alert severity="info" variant="outlined" sx={{ py: 0.5, '& .MuiAlert-message': { fontSize: '0.7rem' } }}>
        <strong>True branch:</strong> Extension is registered and idle — safe to route.<br />
        <strong>False branch:</strong> Extension is offline, busy, or on a call — route elsewhere.<br /><br />
        Output variables available after this block:<br />
        <code>{'{{presence.available}}'}</code>, <code>{'{{presence.registered}}'}</code>, <code>{'{{presence.onCall}}'}</code>
      </Alert>
    </Box>
  );
};

export default CheckExtensionAvailableConfig;
